import { Unidade } from './unidade';
import { UsuarioSistema } from './usuario-sistema';
export class UsuariosUnidades {

	id: number;
	unidade: Unidade;
	usuarioSistema: UsuarioSistema;
	usuarioAlteracao: number;

}